/*=========================================================================================
  File Name: module-notification-banner-mutations.js
  Description: NotificationBanner Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	/**
	 * Cập nhật banner đang active (dữ liệu từ API GET /notifications/active hoặc push SignalR)
	 * @param {Object} state
	 * @param {Object} payload - { id, isActive, message, messageHtml, linkHref }
	 */
	updateBanner(state, payload) {
		state.id = payload && payload.id ? payload.id : null;
		state.isActive = !!(payload && payload.isActive);
		state.message = payload && payload.message ? payload.message : '';
		state.messageHtml = payload && payload.messageHtml ? payload.messageHtml : '';
		state.linkHref = payload && payload.linkHref ? payload.linkHref : '';
	},

	/**
	 * Ẩn banner (không còn bản ghi nào Active)
	 * @param {Object} state
	 */
	hideBanner(state) {
		state.id = null;
		state.isActive = false;
		state.message = '';
		state.messageHtml = '';
		state.linkHref = '';
	}
};
